import React from 'react';
import {
  EmojiEventsOutlined,
  LaptopWindowsOutlined,
  PublicOutlined,
  TrendingUpOutlined,
} from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import Container from '../../components/LandingPage/Container';

/* eslint-disable react/prop-types */

const AcerCard: React.FC<{ icon: React.ReactNode; description: string }> = ({
  icon,
  description,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="13px"
      padding="25px 21px"
      bgcolor="var(--acer-dark)"
      width="100%"
      height="100%"
    >
      <Typography color="var(--acer-green)">{icon}</Typography>
      <Typography
        color="white"
        fontSize="20px"
        fontWeight="500"
        lineHeight="30px"
        letterSpacing="0.19px"
      >
        {description}
      </Typography>
    </Box>
  );
};

const Acer: React.FC = () => {
  const acerCards = [
    {
      icon: <EmojiEventsOutlined />,
      description: 'Líder global no segmento gamer',
    },
    {
      icon: <LaptopWindowsOutlined />,
      description: 'Nova linha corporativa com Windows Pro',
    },
    {
      icon: <PublicOutlined />,
      description: 'Presente em +160 países, com produção própria',
    },
    {
      icon: <TrendingUpOutlined />,
      description: 'Produtos de alta performance, prontos para escala B2B',
    },
  ];

  return (
    <Box bgcolor="var(--acer-green)">
      <Container>
        <Box
          display="flex"
          flexDirection={{ xs: 'column-reverse', md: 'row' }}
          gap={{ xs: '27px', md: '111px' }}
          width="100%"
        >
          <Box
            padding={{ xs: '0 0 41px', md: '147px 0 100px ' }}
            width={{ xs: '100%', md: '482px' }}
            display="flex"
            flexDirection="column"
          >
            <Grid container spacing={1}>
              {acerCards.map(acerCard => (
                <Grid item lg={6} width="100%" key={acerCard.description}>
                  <AcerCard icon={acerCard.icon} description={acerCard.description} />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            gap="27px"
            width={{ xs: '100%', md: '561px' }}
            padding={{ xs: '41px 0 0', md: '86px 0' }}
          >
            <Typography
              color="var(--acer-dark)"
              fontSize="38px"
              fontWeight="600"
              lineHeight="44px"
              letterSpacing="0"
            >
              Acer: uma gigante global agora também no mercado corporativo
            </Typography>
            <Typography
              color="var(--acer-dark)"
              fontSize="20px"
              fontWeight="400"
              lineHeight="30px"
              letterSpacing="0"
            >
              A Acer é um dos maiores players globais de tecnologia, reconhecida por sua liderança
              no segmento gamer e pela venda massiva de produtos de consumo para todo o mundo.
              <br />
              <br />
              Agora, traz para o Brasil uma nova linha de máquinas corporativas de alto desempenho,
              pensadas para empresas que precisam de performance, segurança e robustez.
              <br />
              <br />
              Com modelos equipados com Windows Pro e garantia on-site, a Acer amplia seu portfólio
              para atender demandas do mercado B2B, com a confiabilidade de uma marca presente em
              mais de 160 países.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Acer;
